/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:9cafa29e-a241-4921-b472-ca1072b78910",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_CrGQj2ghJ",
    "aws_user_pools_web_client_id": "17e1lfu4ptbc6kvlj67cvva2he",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "insurance",
            "endpoint": "https://itgses9dk5.execute-api.us-east-2.amazonaws.com/test",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://cjke6fhbqrhttntiiwf64sxbou.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "--REDACTED--"
};


export default awsmobile;
